import type { FaireProductEntity } from "../../entity_types/product";

export const p_prd8xkh7ky: FaireProductEntity = {
  token: "p_prd8xkh7ky",
  type: "product",
  name: "11004 Kawaii Puffy Assorted Stickers-12",
  brandName: "BCmini",
  imageUrl:
    "https://cdn.faire.com/fastly/dd5e05ce573ddfb6c550497695fe8d39711cbe2368135e59a9541a8edf17ba36.jpeg",
  priceDollars: 1.2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f97602edffdcad1cecd77d97ab89b59bb65302c41c89957f7296bd0a9c43c924.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
